/**
 * Lo que se mide del sitio.
 *
 * Del visitante no se guarda la IP sino un hash con la sal del día; eso lo hace la API. Acá
 * sólo se avisa qué pasó, y siempre en silencio: si el pedido falla, la página no se entera.
 */

import { RUTAS } from '@/api/rutas';

const DIRECCION = RUTAS.metricas.registrarVisita;

function avisar(cuerpo: unknown): void {
  if (typeof window === 'undefined') return;

  const texto = JSON.stringify(cuerpo);

  try {
    // sendBeacon sobrevive a que la persona cierre la pestaña, que es justo cuando pasan las
    // cosas que más interesa medir: la búsqueda que abandonó, la última página que miró.
    if (typeof navigator?.sendBeacon === 'function') {
      const bloque = new Blob([texto], { type: 'application/json' });
      if (navigator.sendBeacon(DIRECCION, bloque)) return;
    }

    void fetch(DIRECCION, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: texto,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Medir nunca puede romper la página.
  }
}

export function medirVisita(path: string): void {
  avisar({
    type: 'page_view',
    path,
    referrer: typeof document === 'undefined' ? null : document.referrer || null,
  });
}

export function medirProducto(code: string, brand?: string | null): void {
  avisar({ type: 'product_view', product_code: code, product_brand: brand ?? null });
}

export interface BusquedaMedida {
  query: string;
  result_count: number;
  brand_filter?: string | null;
  category_filter?: string | null;
  quick_filter?: string | null;
}

export function medirBusqueda(busqueda: BusquedaMedida): void {
  avisar({ type: 'search', ...busqueda });
}
